var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlohaaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.764,
    height: 69.359,
    viewBox: "0 0 81.764 69.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG6138",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M636.435,688.868a8.67,8.67,0,0,1-8.476,10.492h-64.42a8.67,8.67,0,0,1-8.477-10.492,41.617,41.617,0,0,1,78.932-7.647A41.241,41.241,0,0,1,636.435,688.868ZM563.546,656.94a8.631,8.631,0,0,0,4.741-1.417,50.178,50.178,0,0,1,54.923,0,8.67,8.67,0,1,0,9.5-14.506,67.521,67.521,0,0,0-73.921,0,8.671,8.671,0,0,0,4.758,15.925Z",
    transform: "translate(-554.866 -630.001)",
    fill: "#f8153b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlohaaLogo);
export default __webpack_public_path__ + "static/media/alohaaLogo.7716b3b6b2852da7dcb8f64a9b5cd307.svg";
export { ForwardRef as ReactComponent };